export default __webpack_public_path__ + "static/media/logout.cc8256c2.svg";